import { classMap } from 'lit/directives/class-map.js';
import { ContextConsumer } from '@lit-labs/context';
import { html, nothing } from 'lit';

import fieldContext from './field.context';

import styles from './field-hint.styles';
import { Component } from '../component';
import type { FieldStatus } from './field.types';

import '../icon';
import '../layout/group';

export interface FieldHintProps extends HTMLElement {
	status?: FieldStatus;
}

export class FieldHint extends Component {
	static override styles = [styles()];

	static override get properties() {
		return {
			status: { type: String },
			slot: { type: String },
		};
	}

	/**
	 * Hint status type.
	 */
	declare status: FieldHintProps['status'];

	declare slot: string;

	private field = new ContextConsumer(this, fieldContext, undefined, true);

	constructor() {
		super();

		this.slot = 'hint';
	}

	override render() {
		const commonClasses = {
			'-status-default': this.#getStatus() === 'default',
			'-status-danger': this.#getStatus() === 'danger',
		};

		return html` <m-group
			gap="spacing-0-5"
			align="center"
			class=${classMap(commonClasses)}
		>
			<slot name="leading"
				>${this.#getStatus() === 'danger'
					? html`<m-icon
							name="attention"
							size="10"
							color="color-danger-60"
					  ></m-icon>`
					: nothing}</slot
			>
			<span
				class=${classMap({
					hint: true,
					...commonClasses,
				})}
				><slot></slot>
			</span>
		</m-group>`;
	}

	#getStatus() {
		return this.status || this.field.value?.status;
	}
}

window.customElements.define('m-field-hint', FieldHint);

declare global {
	interface HTMLElementTagNameMap {
		'm-field-hint': FieldHint;
	}
}
